"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

require("core-js/modules/es.array.concat.js");

var _core = require("../core");

var _utils = require("../utils");

var getLabelPadding = function getLabelPadding(theme) {
  return "".concat(theme.spacing(1.625), "px ").concat(theme.spacing(1), "px ").concat(theme.spacing(1.75), "px ").concat(theme.spacing(1), "px");
};

var getIconPadding = function getIconPadding(theme) {
  return theme.spacing(1.5);
};

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    root: {
      boxShadow: function boxShadow(props) {
        return theme.shadows[props.elevation];
      },
      padding: function padding(props) {
        return props.label ? getLabelPadding(theme) : getIconPadding(theme);
      },
      boxSizing: 'border-box',
      borderRadius: 0,
      borderLeft: "1px solid ".concat(theme.palette.grey[400]),
      borderRight: "1px solid ".concat(theme.palette.grey[400]),
      borderTop: function borderTop(props) {
        return props.elevation > 0 ? 'none' : "1px solid ".concat(theme.palette.grey[400]);
      },
      borderBottom: function borderBottom(props) {
        return props.elevation > 0 ? 'none' : "1px solid ".concat(theme.palette.grey[400]);
      },
      backgroundColor: theme.palette.grey[50],
      flexWrap: 'nowrap',
      '&$disabled': {
        backgroundColor: theme.palette.grey[100],
        boxShadow: 'none',
        '&:before': {
          boxShadow: 'none'
        }
      },
      '&:hover': {
        backgroundColor: theme.palette.grey[100]
      },
      '&$focusVisible': {
        backgroundColor: theme.palette.grey[200]
      },
      '&$selected': {
        backgroundColor: theme.palette.grey[300],
        boxShadow: 'none',
        '&$focusVisible': {
          backgroundColor: theme.palette.grey[200]
        },
        '&:before': {
          boxShadow: 'none'
        }
      }
    },
    icon: {
      color: theme.palette.grey[600],
      '&$disabled': {
        color: theme.palette.grey[400]
      },
      '&$selected': {
        color: theme.palette.primary.main
      }
    },
    label: {
      color: theme.palette.text.primary,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$selected': {
        color: theme.palette.primary.main
      }
    },
    disabled: {},
    focusVisible: {},
    selected: {}
  };
}, {
  name: (0, _core.rochePrefix)('Toggle')
});
exports.useStyles = useStyles;